import React, { useEffect, useState } from 'react';
import {
    Box, Button, Typography, Grid, MenuItem, TableContainer, Table, TableHead, TableBody,
    IconButton, FormControl, Paper, Select,
    Autocomplete
} from "@mui/material";
import {
    Breadcrumb, Cancel, CTSinput, StyledTableCell, StyledTableRow
} from "../../reusableComponent/Reusables";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import dayjs from 'dayjs';

// Services


import uomMasterService from '../../../services/masters/uomMaster.Service';

import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import RmIssuedService from '../../../services/RmIssued.service';
import rmMaster from '../../../services/masters/rmMaster.Service';
import plantMasterService from '../../../services/masters/plantMaster.Service';
const AddRmIssu = () => {
    const navigate = useNavigate();
    const { handleSubmit } = useForm();
    const location = useLocation();
    const editData = location.state || null;

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;
    const depot_id = userInfo.depot_id;
     const plant_id = userInfo.plant_id;
      const unit_id = userInfo.depot_id || userInfo.plant_id;
      const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

    const [successMessage, setSuccessMessage] = useState("");

    const [uom, setUom] = useState([]);
    const [rm, setRm] = useState([]);
    const [plant,setPlant]= useState([]);


    useEffect(() => {
        async function fetchData() {
            try {
                const [uomData, rmData,plantData] = await Promise.all([

                    uomMasterService.getUOMList({ page: 0, size: 999, searchKey: "" }),
                    rmMaster.getRMList({ page: 0, size: 999, searchKey: "" }),
                    plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
                ]);


                setUom(uomData);
                setRm(rmData)
                setPlant(plantData)
            } catch (error) {
                console.error("Data fetching failed", error);
            }
        }

        fetchData();
    }, []);

    const [data, setData] = useState({
        entry_id: editData?.entry_id || null,
        entry_no: editData?.entry_no || '',
       entry_date: editData?.entry_date ? new Date(editData.entry_date).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],

        issued_by: editData?.issued_by || '',
        shift: editData?.shift || '',
        shift_time: editData?.shift_time || '',
        fin_year: editData?.fin_year || '',
        plant_id :editData?.plant_id || '',
    });

    const [rmissueDetails, setRmissueDetails] = useState(
        editData?.table_details
            ? JSON.parse(editData.table_details)
            : [{ srno: "", matrial_code: "", matrial_description: "", qty: "", uom: "" }]
    );

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setData(prev => ({ ...prev, [name]: value }));
    // };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setData(prev => {
            const updatedData = { ...prev, [name]: value };

            if (name === "entry_date") {
                const selectedDate = new Date(value);
                const month = selectedDate.getMonth(); // Jan = 0
                const year = selectedDate.getFullYear();
                const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
                updatedData.fin_year = financialYear;
            }

            return updatedData;
        });
    };


    const handleChangeInput = (e, index) => {
        const { name, value } = e.target;
        const updated = [...rmissueDetails];
        updated[index][name] = value;
        setRmissueDetails(updated);
    };

    const handleAddSPQuotationFields = () => {
        setRmissueDetails(prev => [
            ...prev,
            { srno: "", matrial_code: "", matrial_description: "", qty: "", uom: "" }
        ]);
    };

    const handleRemovepickup = (index) => {
        setRmissueDetails(prev => prev.filter((_, i) => i !== index));
    };

  const onSubmit = async () => {
    const rmissueData = {
        ...data,
        modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        modified_by: editData ? userInfo.user_id : null,
        created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        created_by: editData ? editData.created_by : userInfo.user_id,
        table_details: JSON.stringify(rmissueDetails),
        changedUpdatedValue: "edit",
        depot_id: depot_id,
        plant_id: data.plant_id, 
        plant_id :plant_id,
        short_code: short_code,
        unit_id: unit_id,
    };

    try {
        if (editData) {
            await RmIssuedService.editDeleteRmIssued(rmissueData);
        } else {
            await RmIssuedService.addRmIssued(rmissueData);
        }
        setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
        setTimeout(() => navigate(-1), 1000);
    } catch (error) {
        setSuccessMessage("Error occurred");
    }
};

    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb routeSegments={[{ name: "RM Issued Entry" }]} />
                <Typography className={styles.header_txt}>RM ISSUED ENTRY
</Typography>

                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* {editData === null && rmissueData?.length > 0 && (
                        <Typography className={styles.lastEntry_Txt}>
                            Last Entry No : {rmissueData[0]?.lastScheduleEntryNo || 0}
                        </Typography>
                    )} */}

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography className={styles.label_Txt_add}>Entry No</Typography>
                                <CTSinput
                                    size="small"
                                    fullWidth
                                    name="entry_no"
                                    value={data.entry_no}
                                    onChange={handleChange}
                                    InputProps={{
                                        readOnly: true,
                                        className: styles.CTSinput_Box,
                                        style: { backgroundColor: "#f0f0f0" },
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography className={styles.label_Txt_add}>Entry Date</Typography>
                                <CTSinput
                                    size="small"
                                    fullWidth
                                    type="date"
                                    name="entry_date"
                                    value={data.entry_date}
                                    onChange={handleChange}
                                    InputProps={{ className: styles.CTSinput_Box }}
                                />
                            </Box>
                        </Grid>

                        {/* <Grid item xs={12} sm={6}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    alignItems: { xs: "stretch", sm: "center" },
                                }}
                            >
                                <Typography className={`${styles.label_Txt}`}>
                                    Financial Year
                                </Typography>
                                <CTSinput
                                    size="small"
                                    fullWidth
                                    value={data.fin_year}
                                    variant="outlined"
                                    InputProps={{
                                        readOnly: true,
                                        className: styles.CTSinput_Box,
                                        style: {
                                            backgroundColor: "#f0f0f0",
                                        },
                                    }}
                                />
                            </Box>
                        </Grid> */}

                        <Grid item xs={12} sm={6}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography className={styles.label_Txt_add}>Issued BY</Typography>
                                <CTSinput
                                    type="text"
                                    size="small"
                                    fullWidth
                                    name="issued_by"
                                    value={data.issued_by}
                                    onChange={handleChange}
                                    InputProps={{ className: styles.CTSinput_Box }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                <Typography className={styles.label_Txt_add}>Shift</Typography>

                                <Autocomplete
                                    disablePortal
                                    options={['Shift 1', 'Shift 2', 'Shift 3']}
                                    clearIcon={false} 
                                    getOptionLabel={(option) => (typeof option === 'string' ? option : '')}
                                    value={data.shift || null}
                                    onChange={(event, newValue) => {
                                        handleChange({
                                            target: {
                                                name: 'shift',
                                                value: newValue || '',
                                            },
                                        });
                                    }}
                                    renderOption={(props, option) => (
                                        <MenuItem {...props} className={styles.cts_lable}>
                                            {option}
                                        </MenuItem>
                                    )}
                                    renderInput={(params) => (
                                        <CTSinput
                                            {...params}
                                            // label="Shift"
                                            placeholder="Select or type a shift"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                ...params.InputProps,
                                                className: styles.CTSinput_Box,
                                            }}
                                        />
                                    )}
                                    sx={{ width: '100%' }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Typography className={styles.label_Txt_add}>Shift Time</Typography>
                                <CTSinput
                                    type="time"
                                    size="small"
                                    fullWidth
                                    name="shift_time"
                                    value={data.shift_time}
                                    onChange={handleChange}
                                    InputProps={{ className: styles.CTSinput_Box }}
                                />
                            </Box>
                        </Grid>

                       
<Grid item xs={12} sm={6}>
  <Box
    sx={{
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: { xs: "stretch", sm: "center" },
    }}
  >
    <Typography className={`${styles.label_Txt}`}>
      Plant
    </Typography>
<Autocomplete
  disablePortal
  options={plant || []}
  getOptionLabel={(option) => option.plant_name || ""}
  value={plant.find((p) => p.plant_id === (data.plant_id || plant_id)) || null}
  onChange={(event, newValue) => {
    setData({
      ...data,
      plant_id: newValue ? newValue.plant_id : "",
    });
  }}
  renderOption={(props, option) => (
    <MenuItem {...props} className={styles.cts_lable}>
      {option.plant_name}
    </MenuItem>
  )}
  renderInput={(params) => (
    <CTSinput
      {...params}
      placeholder="Select or type a plant"
      variant="outlined"
      size="small"
      fullWidth
      InputLabelProps={{ shrink: true }}
      InputProps={{
        ...params.InputProps,
        className: styles.CTSinput_Box,
      }}
    />
  )}
  sx={{ width: "100%" }}
  disabled // <-- disables the whole Autocomplete
/>

  </Box>
</Grid>

                        <Grid item xs={12}>
                            <Paper sx={{ width: '100%', }}>
                                <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                                    <Table size="small" stickyHeader>
                                        <TableHead className={styles.table_head_container}>
                                            <StyledTableRow>
                                                <StyledTableCell align="center"
                                                    className={`${styles.table_head}`}
                                                    sx={{ width: '10%' }}>Sr No</StyledTableCell>
                                                <StyledTableCell align="left"
                                                    className={`${styles.table_head}`}> RM Name</StyledTableCell>
                                                {/* <StyledTableCell align="left"
                                                    className={`${styles.table_head}`}>Material Description</StyledTableCell> */}
                                                <StyledTableCell align="left"
                                                    className={`${styles.table_head}`}>Qty</StyledTableCell>
                                                <StyledTableCell align="left"
                                                    className={`${styles.table_head}`}>UOM</StyledTableCell>
                                                <StyledTableCell align="center"
                                                    className={`${styles.table_head}`}>Action</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody sx={{ backgroundColor: '#fff' }}>
                                            {rmissueDetails.map((row, index) => (
                                                <StyledTableRow key={index}>
                                                    <StyledTableCell align="center">{index + 1}</StyledTableCell>

                                                    <StyledTableCell>
                                                        <CTSinput

                                                            select
                                                            fullWidth
                                                            size="small"
                                                            variant="standard"
                                                            name="matrial_code"
                                                            value={row.matrial_code}
                                                            onChange={(e) => handleChangeInput(e, index)}
                                                            InputProps={{
                                                                className: styles.CTSinput_Box,
                                                                disableUnderline: true,
                                                            }}

                                                        >
                                                            {rm?.map((c) => (
                                                                <MenuItem key={c.rm_id} value={c.rm_id} className={styles.cts_lable}>
                                                                    {c.rm_name}
                                                                </MenuItem>
                                                            ))}
                                                        </CTSinput>
                                                    </StyledTableCell>
                                                    

                                                    {/* <StyledTableCell>
                                                        <CTSinput
                                                            fullWidth
                                                            size="small"
                                                            variant="standard"
                                                            name="matrial_description"
                                                            value={row.matrial_description}
                                                            onChange={(e) => handleChangeInput(e, index)}
                                                            InputProps={{
                                                                className: styles.CTSinput_Box,
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell> */}

                                                    <StyledTableCell>
                                                        <CTSinput
                                                            fullWidth
                                                            size="small"
                                                            variant="standard"
                                                            name="qty"
                                                            value={row.qty}
                                                            onChange={(e) => handleChangeInput(e, index)}
                                                            InputProps={{
                                                                className: styles.CTSinput_Box,
                                                                disableUnderline: true,
                                                            }}
                                                        />
                                                    </StyledTableCell>

                                                    <StyledTableCell>
                                                        <FormControl fullWidth variant="standard" size="small">
                                                            <Select
                                                                value={row.uom}
                                                                name="uom"
                                                                onChange={(e) => handleChangeInput(e, index)}
                                                                InputProps={{
                                                                    className: styles.CTSinput_Box,
                                                                    disableUnderline: true,
                                                                }}
                                                                displayEmpty>
                                                                <MenuItem value="" className={`${styles.cts_lable}`}>
                                                                    Select unit
                                                                </MenuItem>
                                                                {uom
                                                                    .filter(item => item.material_type === "rm")
                                                                    .map(item => (
                                                                        <MenuItem className={`${styles.cts_lable}`} key={item.uom_id} value={item.uom}>
                                                                            {item.uom}
                                                                        </MenuItem>
                                                                    ))}
                                                            </Select>
                                                        </FormControl>
                                                    </StyledTableCell>

                                                    <StyledTableCell align="center">
                                                        <IconButton size="small" onClick={handleAddSPQuotationFields}>
                                                            <AddIcon sx={{ fontSize: 16, color: "#1b52d1" }} />
                                                        </IconButton>
                                                        {index !== 0 && (
                                                            <IconButton size="small" onClick={() => handleRemovepickup(index)}>
                                                                <DeleteForeverIcon sx={{ fontSize: 18, color: "red" }} />
                                                            </IconButton>
                                                        )}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Grid>


                        <Grid item xs={12} className={`${styles.grid_input}`}>
                            <Box className={`${styles.btn_container}`}>
                                <Box>
                                    <Button
                                        id={`${styles.btn_save}`}
                                        type="submit"
                                    >
                                        <SaveIcon className={`${styles.btn_cancel_txt}`} />
                                        <Typography className={`${styles.btn_cancel_txt}`}>
                                            {editData ? "Update" : "Save"}
                                        </Typography>
                                    </Button>
                                </Box>
                                <Box>
                                    <Cancel />
                                </Box>
                            </Box>
                        </Grid>










                    </Grid>
                </form>

                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={() => setSuccessMessage("")}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default AddRmIssu;
